/** UK-formatted dates for Admin Console (explicit module so bundlers never drop helpers). */

const UK_DATE = { day: '2-digit', month: '2-digit', year: 'numeric' };
const UK_TIME = { hour: '2-digit', minute: '2-digit' };

function parseAdminDate(value) {
  if (!value) return null;
  try {
    const parsed = value?.toDate ? value.toDate() : new Date(value);
    if (Number.isNaN(parsed.getTime())) return null;
    return parsed;
  } catch {
    return null;
  }
}

/** DD/MM/YYYY */
export function formatUkDate(value) {
  const parsed = parseAdminDate(value);
  if (!parsed) return 'N/A';
  return parsed.toLocaleDateString('en-GB', UK_DATE);
}

/** DD/MM/YYYY, HH:MM */
export function formatUkDateTime(value) {
  const parsed = parseAdminDate(value);
  if (!parsed) return 'N/A';
  return parsed.toLocaleString('en-GB', { ...UK_DATE, ...UK_TIME });
}

/** HH:MM (24h, en-GB) */
export function formatUkTime(value) {
  const parsed = parseAdminDate(value);
  if (!parsed) return 'N/A';
  return parsed.toLocaleTimeString('en-GB', UK_TIME);
}
